import React, { useState } from "react";
import NewCommonServiceContent from "../../../common/NewCommonServices/NewCommonServiceContent";
import ServiceButton from "../../../common/ServiceButton";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import analytic1 from "../../../../assets/images/serviceImages/analytic1.webp";
import analytic2 from "../../../../assets/images/serviceImages/analytic2.webp";
import analytic3 from "../../../../assets/images/serviceImages/analytic3.webp";

type ButtonType = "Analytics" | "YouTube/Insta" | "LinkedIn";


const PersonalBrandingWork = () => {
  const [selectedButton, setSelectedButton] = useState<ButtonType>("Analytics");
  return (
    <div className="">
      <NewCommonServiceContent>
        <div className="">
          <div className="flex flex-wrap justify-center gap-4 sm:gap-10 mb-5 sm:mb-10">
            <ServiceButton
              className={`${
                selectedButton === "Analytics" ? "!card-gradient" : ""
              } text-white`}
              onClick={() => setSelectedButton("Analytics")}
            >
              Analytics
            </ServiceButton>
            <ServiceButton
              className={`${
                selectedButton === "YouTube/Insta" ? "!card-gradient" : ""
              } text-white`}
              onClick={() => setSelectedButton("YouTube/Insta")}
            >
              YouTube/Insta
            </ServiceButton>
            <ServiceButton
              className={`${
                selectedButton === "LinkedIn" ? "!card-gradient" : ""
              } text-white`}
              onClick={() => setSelectedButton("LinkedIn")}
            >
              LinkedIn
            </ServiceButton>
          </div>
          <div>
            {/* Analytic Section */}

            {selectedButton === "Analytics" && (
              <div>
                <div className="h-full">
                  <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    className="flex justify-center items-center"
                    pagination={{
                      type: "bullets",
                      el: ".pagination-progress",
                      clickable: true,
                    }}
                    autoplay={true}
                    spaceBetween={20}
                    slidesPerView={1}
                    navigation={{
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev",
                    }}
                    loop
                  >
                    <SwiperSlide>
                      <img
                        src={analytic1}
                        className="w-full rounded-[16px] object-cover"
                        alt=""
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        src={analytic2}
                        className="w-full rounded-[16px] object-cover"
                        alt=""
                      />
                    </SwiperSlide>
                    <SwiperSlide>
                      <img
                        src={analytic3}
                        className="w-full rounded-[16px] object-cover"
                        alt=""
                      />
                    </SwiperSlide>
                  </Swiper>
                </div>
                <div className="swiper-pagination pagination-progress w-full py-5"></div>
              </div>
            )}

            {/* Linkedin Section */}

            {selectedButton === "LinkedIn" && (
              <div>
                <Swiper
                  modules={[Navigation, Pagination]}
                  className="flex justify-center items-center"
                  pagination={{
                    type: "bullets",
                    el: ".pagination-progress",
                    clickable: true,
                  }}
                  breakpoints={{
                    1024: {
                      slidesPerView: 4,
                      spaceBetween: 20,
                    },
                  }}
                  navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                  }}
                  loop
                >
                  <SwiperSlide className="overflow-hidden rounded-[16px]">
                    <iframe
                      src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7303796149579038720?compact=1"
                      height="499"
                      frameBorder="0"
                      allowFullScreen
                      title="Embedded post"
                      scrolling="no"
                      className="no-scrollbar"
                    ></iframe>
                  </SwiperSlide>
                  <SwiperSlide>
                    <iframe
                      src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7300893624324567040?compact=1"
                      height="499"
                      frameBorder="0"
                      allowFullScreen
                      title="Embedded post"
                      scrolling="no"
                      className="no-scrollbar"
                    ></iframe>
                  </SwiperSlide>
                  <SwiperSlide>
                    <iframe
                      src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7298348318709927937?compact=1"
                      height="499"
                      frameBorder="0"
                      allowFullScreen
                      title="Embedded post"
                      scrolling="no"
                      className="no-scrollbar"
                    ></iframe>
                  </SwiperSlide>
                  <SwiperSlide>
                    <iframe
                      src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7295805217965555712?compact=1"
                      height="499"
                      frameBorder="0"
                      allowFullScreen
                      title="Embedded post"
                      scrolling="no"
                      className="no-scrollbar"
                    ></iframe>
                  </SwiperSlide>
                  <SwiperSlide>
                    <iframe
                      src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7293323919720099844?compact=1"
                      height="499"
                      frameBorder="0"
                      allowFullScreen
                      title="Embedded post"
                      scrolling="no"
                      className="no-scrollbar"
                    ></iframe>
                  </SwiperSlide>
                  <SwiperSlide>
                    <iframe
                      src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7291106107865874432?compact=1"
                      height="499"
                      frameBorder="0"
                      allowFullScreen
                      title="Embedded post"
                      scrolling="no"
                      className="no-scrollbar"
                    ></iframe>
                  </SwiperSlide>
                </Swiper>
                <div className="swiper-pagination pagination-progress w-full py-5"></div>
              </div>
            )}

            {/* Youtube Section */}

            {selectedButton === "YouTube/Insta" && (
              <div>
                <Swiper
                  modules={[Navigation, Pagination]}
                  className="flex justify-center items-center"
                  pagination={{
                    type: "bullets",
                    el: ".pagination-progress",
                    clickable: true,
                  }}
                  breakpoints={{
                    1024: {
                      slidesPerView: 4,
                      spaceBetween: 20,
                    },
                  }}
                  navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                  }}
                  loop
                >
                  <SwiperSlide>
                    <iframe
                      height="500"
                      src="https://www.youtube.com/embed/EoCLB5_pXqw"
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="no-scrollbar rounded-[16px]"
                    ></iframe>
                  </SwiperSlide>
                  <SwiperSlide>
                    <iframe
                      height="500"
                      src="https://www.youtube.com/embed/jCa-sGRyOW4"
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="no-scrollbar rounded-[16px]"
                    ></iframe>
                  </SwiperSlide>
                  <SwiperSlide>
                    <iframe
                      height="500"
                      src="https://www.youtube.com/embed/xLOhN9pcLlU"
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="no-scrollbar rounded-[16px]"
                    ></iframe>
                  </SwiperSlide>
                  <SwiperSlide>
                    <iframe
                      height="500"
                      src="https://www.youtube.com/embed/D6szxHMJZhA"
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="no-scrollbar rounded-[16px]"
                    ></iframe>
                  </SwiperSlide>
                  <SwiperSlide>
                    <iframe
                      height="500"
                      src="https://www.youtube.com/embed/Eo453hAve-g"
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="no-scrollbar rounded-[16px]"
                    ></iframe>
                  </SwiperSlide>
                  <SwiperSlide>
                    <iframe
                      height="500"
                      src="https://www.youtube.com/embed/GAEtKKtCMO0"
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="no-scrollbar rounded-[16px]"
                    ></iframe>
                  </SwiperSlide>
                  <SwiperSlide>
                    <iframe
                      height="500"
                      src="https://www.youtube.com/embed/SP9Zj2rIJ0I"
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="no-scrollbar rounded-[16px]"
                    ></iframe>
                  </SwiperSlide>
                  <SwiperSlide>
                    <iframe
                      height="500"
                      src="https://www.youtube.com/embed/IcdrN5ncn8Q"
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="no-scrollbar rounded-[16px]"
                    ></iframe>
                  </SwiperSlide>
                </Swiper>
                <div className="swiper-pagination pagination-progress w-full py-5"></div>
              </div>
            )}
          </div>
        </div>
      </NewCommonServiceContent>
    </div>
  );
};

export default PersonalBrandingWork;
